import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-cWhite group-[.toaster]:text-text group-[.toaster]:border-cMediumGrey group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-cDarkGrey",
          actionButton:
            "group-[.toast]:bg-cYellow group-[.toast]:text-cGreen",
          cancelButton:
            "group-[.toast]:bg-cLightGrey group-[.toast]:text-cDarkGrey",
          success:
            "group-[.toaster]:!bg-cLightGreen group-[.toaster]:!text-text group-[.toaster]:!border-cSuccess",
          error:
            "group-[.toaster]:!bg-cDenied group-[.toaster]:!text-text group-[.toaster]:!border-cError",
          info:
            "group-[.toaster]:!bg-cYellow group-[.toaster]:!text-text group-[.toaster]:!border-cYellow",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
